import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import store from '@/store/store'
import { computed, ComputedRef } from 'vue'

interface ReturnUseCompany {
  defaultStage: ComputedRef<boolean>
  hasInvoiceTemplate: ComputedRef<boolean>
}

export default function useCompany(): ReturnUseCompany {
  const defaultStage: ComputedRef<boolean> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getCompanyDefaultStage`]
  )
  const hasInvoiceTemplate: ComputedRef<boolean> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getCompanyTemplateInvoices`]
  )
  return {
    defaultStage,
    hasInvoiceTemplate
  }
}
